import type { ProjectMember, ProjectMemberRepository } from './RepositoryInterfaces.js';

export const membershipId = (projectId: string, uid: string): string => `${projectId}_${uid}`;

export class InMemoryProjectMemberRepository implements ProjectMemberRepository {
  private members: Map<string, ProjectMember> = new Map();

  async findById(id: string): Promise<ProjectMember | undefined> {
    return this.members.get(id);
  }

  async findByProjectId(projectId: string): Promise<ProjectMember[]> {
    return Array.from(this.members.values()).filter((m) => m.projectId === projectId);
  }

  async findByUserId(uid: string): Promise<ProjectMember[]> {
    return Array.from(this.members.values()).filter((m) => m.uid === uid);
  }

  async findByProjectAndUser(projectId: string, uid: string): Promise<ProjectMember | undefined> {
    return this.members.get(membershipId(projectId, uid));
  }

  async save(member: ProjectMember): Promise<ProjectMember> {
    this.members.set(membershipId(member.projectId, member.uid), member);
    return member;
  }

  async delete(id: string): Promise<void> {
    this.members.delete(id);
  }

  seed(members: ProjectMember[]): void {
    members.forEach((m) => this.members.set(membershipId(m.projectId, m.uid), m));
  }
}

export const createInMemoryProjectMemberRepository = (): InMemoryProjectMemberRepository =>
  new InMemoryProjectMemberRepository();
